var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "f7-page",
    {
      staticClass: "no-swipeback",
      attrs: { "login-screen": "", id: "login" },
      on: { "page:reinit": function ($event) {} },
    },
    [
      _c(
        "div",
        { staticClass: "body bgLogin" },
        [
          _c("b-row", { staticClass: "h-100" }, [
            _c("div", { staticClass: "loginPanel loginHeight" }, [
              _c(
                "div",
                [
                  _c(
                    "b-row",
                    { staticClass: "panel-heading ajust text-center mb-2rem" },
                    [
                      _c("b-col", { attrs: { cols: "2" } }),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-2", attrs: { cols: "8" } },
                        [
                          _c(
                            "b-navbar-brand",
                            { staticClass: "mr-0 w-80", attrs: { href: "#" } },
                            [
                              _c("img", {
                                staticClass: "heritage largescreen w-100",
                                attrs: {
                                  src: _vm.imgVarsLong,
                                  alt: "MoneyRoadBNPP",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _vm.activationCode
                            ? _c("h4", { staticClass: "panel-title" }, [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(
                                      _vm.$t("loginPage.sign_in_not_activated")
                                    ) +
                                    "\n              "
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { staticClass: "p-0", attrs: { cols: "2" } },
                        [
                          _c(
                            "b-dropdown",
                            {
                              staticClass: "no-back",
                              attrs: {
                                left: "",
                                "toggle-class":
                                  "border-0 p-0 m-md-2 text-dark z-5",
                              },
                              model: {
                                value: _vm.language,
                                callback: function ($$v) {
                                  _vm.language = $$v
                                },
                                expression: "language",
                              },
                            },
                            [
                              _c("template", { slot: "button-content" }, [
                                _c("img", {
                                  staticClass: "flag-nav",
                                  attrs: {
                                    src:
                                      _vm.language === "FR"
                                        ? _vm.logoFlagFR
                                        : _vm.logoFlagEN,
                                  },
                                }),
                                _c(
                                  "span",
                                  { staticClass: "d-none-max-1459px mr-1" },
                                  [_vm._v(_vm._s(_vm.labelLanguage))]
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.langOptions, function (option) {
                                return _c(
                                  "b-dropdown-item",
                                  {
                                    key: option.value,
                                    staticClass: "dropdown-item-web-header",
                                    on: {
                                      click: function ($event) {
                                        return _vm.languageCountry(option.value)
                                      },
                                    },
                                  },
                                  [
                                    option.value === "FR"
                                      ? _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: { src: _vm.logoFlagFR },
                                        })
                                      : _c("img", {
                                          staticClass: "flag-nav",
                                          attrs: { src: _vm.logoFlagEN },
                                        }),
                                    _vm._v(" "),
                                    _c("span", [_vm._v(_vm._s(option.text))]),
                                  ]
                                )
                              }),
                            ],
                            2
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      on: {
                        keyup: function ($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.quickLogin()
                        },
                      },
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { cols: "8", offset: "2" },
                            },
                            [
                              _c("form-write-group-label-input", {
                                attrs: {
                                  inputType: "text",
                                  inputLabel: _vm.$t("common.identifier"),
                                  inputClass: "inputLogin",
                                  autocomplete: "off",
                                },
                                model: {
                                  value: _vm.credentials.Login,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.credentials, "Login", $$v)
                                  },
                                  expression: "credentials.Login",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            {
                              staticClass: "form-group",
                              attrs: { cols: "8", offset: "2" },
                            },
                            [
                              _c("div", [
                                _c("label", [
                                  _vm._v(_vm._s(_vm.$t("common.pwd"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "d-flex" }, [
                                  _vm.passwordFieldType === "checkbox"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.credentials.Password,
                                            expression: "credentials.Password",
                                          },
                                        ],
                                        staticClass:
                                          "form-control inputAccordionForm inputLogin h-30px",
                                        attrs: {
                                          autocomplete: "off",
                                          type: "checkbox",
                                        },
                                        domProps: {
                                          checked: Array.isArray(
                                            _vm.credentials.Password
                                          )
                                            ? _vm._i(
                                                _vm.credentials.Password,
                                                null
                                              ) > -1
                                            : _vm.credentials.Password,
                                        },
                                        on: {
                                          change: function ($event) {
                                            var $$a = _vm.credentials.Password,
                                              $$el = $event.target,
                                              $$c = $$el.checked ? true : false
                                            if (Array.isArray($$a)) {
                                              var $$v = null,
                                                $$i = _vm._i($$a, $$v)
                                              if ($$el.checked) {
                                                $$i < 0 &&
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "Password",
                                                    $$a.concat([$$v])
                                                  )
                                              } else {
                                                $$i > -1 &&
                                                  _vm.$set(
                                                    _vm.credentials,
                                                    "Password",
                                                    $$a
                                                      .slice(0, $$i)
                                                      .concat(
                                                        $$a.slice($$i + 1)
                                                      )
                                                  )
                                              }
                                            } else {
                                              _vm.$set(
                                                _vm.credentials,
                                                "Password",
                                                $$c
                                              )
                                            }
                                          },
                                        },
                                      })
                                    : _vm.passwordFieldType === "radio"
                                    ? _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.credentials.Password,
                                            expression: "credentials.Password",
                                          },
                                        ],
                                        staticClass:
                                          "form-control inputAccordionForm inputLogin h-30px",
                                        attrs: {
                                          autocomplete: "off",
                                          type: "radio",
                                        },
                                        domProps: {
                                          checked: _vm._q(
                                            _vm.credentials.Password,
                                            null
                                          ),
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.$set(
                                              _vm.credentials,
                                              "Password",
                                              null
                                            )
                                          },
                                        },
                                      })
                                    : _c("input", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.credentials.Password,
                                            expression: "credentials.Password",
                                          },
                                        ],
                                        staticClass:
                                          "form-control inputAccordionForm inputLogin h-30px",
                                        attrs: {
                                          autocomplete: "off",
                                          type: _vm.passwordFieldType,
                                        },
                                        domProps: {
                                          value: _vm.credentials.Password,
                                        },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.$set(
                                              _vm.credentials,
                                              "Password",
                                              $event.target.value
                                            )
                                          },
                                        },
                                      }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "icon icon-password mt-2 pt-1",
                                    class: [
                                      _vm.isPasswordFieldHidden
                                        ? "fa-duotone fa-eye"
                                        : "fa-duotone fa-eye-slash",
                                    ],
                                    on: { click: _vm.toggleVisibility },
                                  }),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-row",
                        [
                          _vm.withPassword
                            ? _c("b-col", { staticClass: "form-group" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "form-control passwordControl d-flex h-25px",
                                  },
                                  [
                                    _vm.passwordFieldType === "checkbox"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.credentials.PasswordRepeat,
                                              expression:
                                                "credentials.PasswordRepeat",
                                            },
                                          ],
                                          staticClass: "border-0 w-100",
                                          attrs: {
                                            placeholder:
                                              _vm.loginpage_PasswordRepeat,
                                            autocomplete: "off",
                                            type: "checkbox",
                                          },
                                          domProps: {
                                            checked: Array.isArray(
                                              _vm.credentials.PasswordRepeat
                                            )
                                              ? _vm._i(
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                  null
                                                ) > -1
                                              : _vm.credentials.PasswordRepeat,
                                          },
                                          on: {
                                            change: function ($event) {
                                              var $$a =
                                                  _vm.credentials
                                                    .PasswordRepeat,
                                                $$el = $event.target,
                                                $$c = $$el.checked
                                                  ? true
                                                  : false
                                              if (Array.isArray($$a)) {
                                                var $$v = null,
                                                  $$i = _vm._i($$a, $$v)
                                                if ($$el.checked) {
                                                  $$i < 0 &&
                                                    _vm.$set(
                                                      _vm.credentials,
                                                      "PasswordRepeat",
                                                      $$a.concat([$$v])
                                                    )
                                                } else {
                                                  $$i > -1 &&
                                                    _vm.$set(
                                                      _vm.credentials,
                                                      "PasswordRepeat",
                                                      $$a
                                                        .slice(0, $$i)
                                                        .concat(
                                                          $$a.slice($$i + 1)
                                                        )
                                                    )
                                                }
                                              } else {
                                                _vm.$set(
                                                  _vm.credentials,
                                                  "PasswordRepeat",
                                                  $$c
                                                )
                                              }
                                            },
                                          },
                                        })
                                      : _vm.passwordFieldType === "radio"
                                      ? _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.credentials.PasswordRepeat,
                                              expression:
                                                "credentials.PasswordRepeat",
                                            },
                                          ],
                                          staticClass: "border-0 w-100",
                                          attrs: {
                                            placeholder:
                                              _vm.loginpage_PasswordRepeat,
                                            autocomplete: "off",
                                            type: "radio",
                                          },
                                          domProps: {
                                            checked: _vm._q(
                                              _vm.credentials.PasswordRepeat,
                                              null
                                            ),
                                          },
                                          on: {
                                            change: function ($event) {
                                              return _vm.$set(
                                                _vm.credentials,
                                                "PasswordRepeat",
                                                null
                                              )
                                            },
                                          },
                                        })
                                      : _c("input", {
                                          directives: [
                                            {
                                              name: "model",
                                              rawName: "v-model",
                                              value:
                                                _vm.credentials.PasswordRepeat,
                                              expression:
                                                "credentials.PasswordRepeat",
                                            },
                                          ],
                                          staticClass: "border-0 w-100",
                                          attrs: {
                                            placeholder:
                                              _vm.loginpage_PasswordRepeat,
                                            autocomplete: "off",
                                            type: _vm.passwordFieldType,
                                          },
                                          domProps: {
                                            value:
                                              _vm.credentials.PasswordRepeat,
                                          },
                                          on: {
                                            input: function ($event) {
                                              if ($event.target.composing) {
                                                return
                                              }
                                              _vm.$set(
                                                _vm.credentials,
                                                "PasswordRepeat",
                                                $event.target.value
                                              )
                                            },
                                          },
                                        }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass: "icon icon-password",
                                      class: [
                                        _vm.isPasswordFieldHidden
                                          ? "fa-duotone fa-eye"
                                          : "fa-duotone fa-eye-slash",
                                      ],
                                      on: { click: _vm.toggleVisibility },
                                    }),
                                  ]
                                ),
                              ])
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "loginButtons" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "8", offset: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "primary", size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.authUser()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("loginPage.lgn_on_login_page")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    { staticClass: "loginButtons" },
                    [
                      _c(
                        "b-col",
                        { attrs: { cols: "8", offset: "2" } },
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "secondary", size: "lg" },
                              on: {
                                click: function ($event) {
                                  return _vm.redirectSSO()
                                },
                              },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(
                                    _vm.$t("loginPage.lgnsso_on_login_page")
                                  ) +
                                  "\n              "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "footer",
                    { staticClass: "pt-3 pb-1" },
                    [
                      _c(
                        "b-row",
                        [
                          _c(
                            "b-col",
                            { staticClass: "xs-12 text-center" },
                            [
                              _c(
                                "b-col",
                                {
                                  staticClass:
                                    "d-flex justify-content-center align-items-center",
                                },
                                [
                                  _c("img", {
                                    staticClass: "logoStreammind",
                                    attrs: { src: _vm.logoStreammind },
                                  }),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      " " + _vm._s(_vm.$t("common.copyright"))
                                    ),
                                  ]),
                                  _vm._v(" "),
                                  _c("span", [_vm._v(_vm._s(_vm.version))]),
                                ]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
          ]),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }